function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M38.334 34.74h-5.507v5.536h-5.654V34.74h-5.507v-5.683h5.507v-5.536h5.654v5.536h5.507v5.683zm6.668-15.1H31.154c-1.062 0-2.608-.705-3.307-1.506l-1-1.152C25.878 15.872 23.968 15 22.5 15H15A3.01 3.01 0 0012 18.015v23.198a3.01 3.01 0 002.998 3.015h30.003A3.01 3.01 0 0048 41.213V22.655a3.01 3.01 0 00-2.998-3.015z",
  id: "a"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M60 30c0 16.568-13.432 30-30 30C13.432 60 0 46.568 0 30 0 13.432 13.432 0 30 0c16.568 0 30 13.432 30 30",
  fill: "#06B0E4"
}), React.createElement("use", {
  fill: "#7ED2EF",
  xlinkHref: "#a"
}));

var SvgIconCircleAllSaved = function SvgIconCircleAllSaved(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconCircleAllSaved;